import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../../store';
import { closeSearchModal } from '../../store/reducers/modal/modalSearchSlice';
import { setCheckIn, setDeparture, setGuests } from '../../store/reducers/search/searchDataSlice';
import { openLoginModal } from '../../store/reducers/modal/loginModalSlice';

import SearchField from '../SearchField';
import Button from '../../UI/Button';
import Checkbox from '../../UI/Checkbox';
import Modal from '../../UI/Modal';

import { CALENDAR, GUESTS } from '../../app_constants';
import bemClassName from '../../utils/bem';
import { IBookigPanel, IManager } from './interface';

import './index.scss';
import PrivateData from '../../API/PrivateData';
import SearchModal from '../SearchModal';
import DealPanel from '../DealPanel';
import {
  formatedBookingPanelDateForReservation,
  formatedCalendarDays,
} from '../../utils/calendarDayUtils';
import Loading from '../../UI/Loading';
import getQueryParam from '../../utils/queryParams';
import CatalogData from '../../API/CatalodData';

const bookingPanel = bemClassName('booking-panel');

const BookingPanel: React.FC<IBookigPanel> = ({ side, id, price, deposit, load }) => {
  const [isHide, setHide] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [cashBack, setCashBack] = useState<boolean>(false);
  const [apartmentAvailable, setApartmentAvailable] = useState<boolean>(true);

  const [bookingPhoneNumber, setBookingPhoneNumber] = useState<string>();
  const [totalBasePrice, setTotalBasePrice] = useState<number | null>();
  const [allSelectedDays, setAllSelectedDays] = useState<number>();
  const [bonus, setBonus] = useState<number>();
  const [discount, setDiscount] = useState<number>();
  const [priceIncludingDiscount, setPriceIncludingDiscount] = useState<number>();
  const [discountSum, setDiscountSum] = useState<number>();
  const [depositSum, setDepositSum] = useState<number>();
  const [statusBooking, setStatusBooking] = useState<any>();
  const [stageId, setStageId] = useState<any>();
  const [reservBeginDate, setReservBeginDate] = useState<string>();
  const [discountPrice, setDiscountPrice] = useState<number | undefined>(price);
  const [reservEndDate, setReservEndDate] = useState<string>();
  const [userDealsId, setUserDealsId] = useState<number>();
  const [noGuests, setNoGuests] = useState<boolean>(false);
  const [noDates, setNoDates] = useState<boolean>(false);
  const [contactless, setContactless] = useState<any>();
  const [addDealError, setAddDealError] = useState<string | undefined | null>(null);

  const [dealTotal, setDealTotal] = useState<number | undefined>(undefined);
  const [dealFullpay, setDealFullpay] = useState<number | undefined>(undefined);
  const [dealPrepay, setDealPrepay] = useState<number | undefined>(undefined);
  const [dealAllpay, setDealAllpay] = useState<boolean | false>(false);
  const [dealRisk, setDealRisk] = useState<boolean | undefined>(undefined);
  const [dealSurcharge, setDealSurcharge] = useState<number | undefined>(undefined);
  const [dealDiscount, setDealDiscount] = useState<number | undefined>(undefined);
  const [dealBonus, setDealBonus] = useState<number | undefined>(undefined);
  const [dealCashback, setDealCashback] = useState<boolean>(false);
  const [dealManager, setDealManager] = useState<IManager>();
  const [dealTimeout, setDealTimeout] = useState<string | undefined>(undefined);
  const [dealWiFiLogin, setDealWiFiLogin] = useState<string | undefined>(undefined);
  const [dealWiFiPassword, setDealWiFiPassword] = useState<string | undefined>(undefined);
  const [dealCode, setDealCode] = useState<string | undefined>(undefined);
  const [anotherDeal, setAnotherDeal] = useState<boolean>(false);

  const guests = useSelector((state: RootState) => state.searchData.guests);
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const calendarSelected = useSelector((state: RootState) => state.searchData.calendarSelected);

  const typeOpenSearchModal = useSelector(
    (state: RootState) => state.modalSearch.typeOpenSearchModal,
  );

  const bookingFieldsList = useRef<HTMLInputElement>(null);
  const searchFieldsListCalendar = useRef<HTMLInputElement>(null);

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleApplyForReservation = () => {
    setIsLoading(true);
    setDisabledButton(false);
    if (
      id &&
      calendarSelected &&
      calendarSelected.checkIn &&
      calendarSelected.departure &&
      guests
    ) {
      PrivateData.getPrivateUserApartmentReservation(
        id,
        formatedBookingPanelDateForReservation(calendarSelected.checkIn),
        formatedBookingPanelDateForReservation(calendarSelected.departure),
        guests[0],
        guests[1],
        cashBack,
        bookingPhoneNumber,
      )
        .then((item) => {
          setIsLoading(false);
          setDisabledButton(true);
          if (item.error) {
            setAddDealError(item.error);
          } else {
            setStatusBooking(item.status);
            setStageId(item.stage_id);
            setUserDealsId(item.id);
            setReservBeginDate(item.reserve_begin);
            setReservEndDate(item.reserve_end);
            setAnotherDeal(false);
          }
          setHide(false);
          window.history.replaceState({}, document.title, window.location.pathname);
        })
        .catch(() => {
          setHide(false);
          setAddDealError('Ошибка создания брони');
        });
    } else {
      setHide(false);
      setAddDealError('Не все параметры брони указаны');
    }
  };

  const handleBooking = () => {
    if (
      !isLogin &&
      calendarSelected &&
      calendarSelected.checkIn &&
      calendarSelected.departure &&
      guests
    ) {
      dispatch(openLoginModal());
      const token = crypto.randomUUID();
      sessionStorage.setItem('booking_intent', token);
      const searchParams = new URLSearchParams(window.location.search);
      const dataString = JSON.stringify({
        begin: formatedBookingPanelDateForReservation(calendarSelected.checkIn),
        end: formatedBookingPanelDateForReservation(calendarSelected.departure),
        adult_count: guests[0],
        child_count: guests[1],
      });
      searchParams.set('booking_intent', token);
      searchParams.set('data', dataString);
      window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);
    } else {
      handleApplyForReservation();
    }
  };

  useEffect(() => {
    if (isLogin !== null && isLogin && id && !statusBooking) {
      const intentFlag = getQueryParam('booking_intent');
      const storedToken = sessionStorage.getItem('booking_intent');
      if (intentFlag || storedToken) {
        sessionStorage.removeItem('booking_intent');
        window.history.replaceState({}, '', `${window.location.pathname}`);
      }
      if (storedToken && intentFlag === storedToken) {
        handleApplyForReservation();
      }
      const dataString = getQueryParam('data');
      if (dataString) {
        try {
          const decodedString = decodeURIComponent(dataString);
          const parsedData = JSON.parse(decodedString);
          if (parsedData.begin && parsedData.end) {
            dispatch(setCheckIn(parsedData.begin));
            dispatch(setDeparture(parsedData.end));
          }
          if (parsedData.cashback) {
            dispatch(setCashBack(parsedData.cashback));
          }
          if (parsedData.adult_count !== undefined && parsedData.child_count !== undefined) {
            dispatch(setGuests([Number(parsedData.adult_count), Number(parsedData.child_count)]));
          }
        } catch (e) {
          console.error('Ошибка парсинга JSON из URL:', e);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (calendarSelected && (!calendarSelected.checkIn || !calendarSelected.departure)) {
      setNoDates(true);
      setNoGuests(false);
    } else {
      setNoDates(false);
    }
  }, [calendarSelected]);

  useEffect(() => {
    if (id && calendarSelected && calendarSelected.checkIn && calendarSelected.departure) {
      if (guests && guests?.length > 0) {
        setNoGuests(false);
      } else {
        setNoGuests(true);
      }
      setIsLoading(true);
      load(false);
      CatalogData.checkBooking({
        productId: id,
        begin: formatedCalendarDays(calendarSelected.checkIn),
        end: formatedCalendarDays(calendarSelected.departure),
      }).then((item) => {
        setIsLoading(false);
        setTotalBasePrice(item.base_total);
        setBonus(item.bonus);
        setDiscount(item.discount);
        setDiscountPrice(price);
        setContactless(item.contactless);
        setPriceIncludingDiscount(item.total);
        setDiscountSum(item.discount_summ);
        setAllSelectedDays(item.duration);
        setApartmentAvailable(item.free);
        setDepositSum(item.deposit);
        setAddDealError(null);
      });
    }
  }, [id, isLogin, calendarSelected]);

  useEffect(() => {
    const isFormValid = Boolean(
      calendarSelected?.checkIn && calendarSelected?.departure && guests && guests?.length > 0,
    );
    if (isFormValid) {
      setNoGuests(false);
      setNoDates(false);
      setDisabledButton(true);
      setAddDealError(null);
    } else {
      setDisabledButton(false);
    }
  }, [calendarSelected, guests]);

  useEffect(() => {
    if (id && isLogin !== null && isLogin) {
      PrivateData.getPrivateUserDealStatusBooking(id)
        .then((item) => {
          if (item.data.length > 0) {
            const searchParams = new URLSearchParams(window.location.search);
            const beginParam = searchParams.get('begin');
            let data = item.data[0];
            if (beginParam) {
              const foundData = item.data.find((items: any) => items.begindate === beginParam);
              if (foundData) {
                data = foundData;
              }
            }
            setStatusBooking(data.status);
            setStageId(data.stage_id);
            setContactless(data.contactless);
            setReservBeginDate(data.reserve_begin);
            setReservEndDate(data.reserve_end);
            setUserDealsId(data.id);
            setDealTotal(data.total);
            setDealSurcharge(data.surcharge);
            setDealCashback(data.cashback);
            setDealTimeout(data.timeout);
            setDealBonus(data.bonus);
            setDealRisk(data.risk);
            setDealDiscount(data.discount);
            setDealPrepay(data.prepay);
            setDealAllpay(data.allpay);
            setDealFullpay(data.fullpay);
            setDealManager(data.manager);
            if (data.product) {
              setDealWiFiLogin(data.product.wifi_login);
              setDealWiFiPassword(data.product.wifi_password);
              setDealCode(data.product.code);
            }
          }
        })
        .catch(() => {
          return null;
        });
    }
  }, [calendarSelected, guests, isLogin, statusBooking]);

  useEffect(() => {
    if (isLogin !== null && isLogin) {
      PrivateData.getPrivateUser().then((item) => {
        if (item.phone && item.phone.international && item.phone.international !== null) {
          setBookingPhoneNumber(item.phone.international);
        }
      });
    }
  }, [isLogin]);

  useEffect(() => {
    if (calendarSelected && calendarSelected.checkIn && calendarSelected.departure) {
      dispatch(closeSearchModal());
    }
  }, [calendarSelected]);

  useEffect(() => {
    const onClick = (event: any) =>
      bookingFieldsList.current?.contains(event.target) ||
      searchFieldsListCalendar.current?.contains(event.target) ||
      dispatch(closeSearchModal());
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return !statusBooking || anotherDeal ? (
    <>
      <div className={bookingPanel({ side, hide: !side && isHide })}>
        {side || !isHide ? (
          <>
            <h4 className={bookingPanel('header-contacted')}>Бронирование</h4>
            <div ref={bookingFieldsList} className={bookingPanel('fields-list')}>
              <SearchField
                title="Заезд"
                placeholder="Заезд"
                textValue={calendarSelected === null ? calendarSelected : calendarSelected.checkIn}
                type={CALENDAR}
                isValidExternal={!noDates}
                booking
                calendarMini
              />
              <SearchField
                title="Отъезд"
                placeholder="Отъезд"
                textValue={
                  calendarSelected === null ? calendarSelected : calendarSelected.departure
                }
                type={CALENDAR}
                isValidExternal={!noDates}
                booking
                calendarMini
              />
              <SearchField
                title="Гости"
                placeholder="Гости"
                textValue={guests}
                isValidExternal={!noGuests}
                type={GUESTS}
                booking
              />
              {typeOpenSearchModal === CALENDAR && (
                <SearchModal calendarMini type={CALENDAR} data={[]} />
              )}
            </div>
            {isLoading && <Loading externalClassName={bookingPanel('loading')} />}
            {!isLoading && totalBasePrice
              ? apartmentAvailable && (
                  <>
                    <p className={bookingPanel('price', { bonus: true })}>
                      Бонусные баллы <span>+{bonus}</span>
                    </p>
                    {depositSum && (
                      <p className={bookingPanel('price', { deposit: true })}>
                        Возвращаемый залог <span>{depositSum} ₽</span>
                      </p>
                    )}
                    <div className={bookingPanel('group')}>
                      {!cashBack && discountSum !== undefined && discountSum > 0 && (
                        <p className={bookingPanel('price')}>
                          Скидка <span>{discountSum} ₽</span>
                        </p>
                      )}
                      <h4 className={bookingPanel('price')}>
                        Итого <span>{!cashBack ? priceIncludingDiscount : totalBasePrice} ₽</span>
                      </h4>
                      {/* {!cashBack && ( */}
                      <p
                        className={bookingPanel('text', { show_modal: true })}
                        onClick={handleOpenModal}>
                        Показать расчёт цены
                      </p>
                      {/* )} */}
                    </div>
                  </>
                )
              : !isLoading && (
                  <h4 className={bookingPanel('price')}>
                    Цена за сутки <span>{discountPrice} ₽</span>
                  </h4>
                )}
            {apartmentAvailable && (
              <div className={bookingPanel('group')}>
                <Button
                  handleExternal={handleBooking}
                  text="Забронировать"
                  externalClassName={bookingPanel('button')}
                  disable={!disabledButton}
                />
                <p className={bookingPanel('text', { center: true })}>
                  Подавая заявку на бронирование, Вы соглашаетесь{' '}
                  <a href="/services#agreement" target="_blank" rel="noopener noreferrer">
                    с правилами нашего сервиса
                  </a>
                </p>
              </div>
            )}
            {apartmentAvailable && discountSum !== undefined && discountSum > 0 && (
              <Checkbox
                text="Получить скидку в виде кешбека"
                externalClassName={bookingPanel('checkbox')}
                handleExternal={(value: boolean) => setCashBack(value)}
                checked={cashBack}
              />
            )}
            {!apartmentAvailable && apartmentAvailable !== undefined && !isLoading && (
              <div className={bookingPanel('date-error-info')}>
                На указанные даты объект уже занят. Попробуйте выбрать другие даты.
              </div>
            )}
          </>
        ) : (
          <>
            <Button
              text="Бронирование"
              externalClassName={bookingPanel('button')}
              handleExternal={() => setHide(false)}
            />
          </>
        )}
        {addDealError && <h3 className={bookingPanel('error')}>{addDealError}</h3>}
      </div>
      <Modal open={isOpen} handleClose={handleCloseModal}>
        <h3>Расчёт цены</h3>
        <div className={bookingPanel('price-calculation')}>
          <h4 className={bookingPanel('price-calculation-text')}>
            <span className={bookingPanel('price-calculation-title')}>Цена квартиры</span>
            {price} ₽
          </h4>
          <h4 className={bookingPanel('price-calculation-text')}>x</h4>
          <h4 className={bookingPanel('price-calculation-text')}>
            <span className={bookingPanel('price-calculation-title')}>Количество дней</span>
            {allSelectedDays}
          </h4>
          <h4 className={bookingPanel('price-calculation-text')}>=</h4>
          <h4 className={bookingPanel('price-calculation-text')}>
            <span className={bookingPanel('price-calculation-title')}>Общая сумма</span>
            {totalBasePrice} ₽
          </h4>
        </div>
        {discountSum !== 0 && (
          <div className={bookingPanel('price-calculation')}>
            <h4 className={bookingPanel('price-calculation-text')}>
              <span className={bookingPanel('price-calculation-title')}>Общая сумма</span>
              {totalBasePrice} ₽
            </h4>
            {discount === 1 ? (
              <h4 className={bookingPanel('price-calculation-text')}>-</h4>
            ) : (
              <h4 className={bookingPanel('price-calculation-text')}>x</h4>
            )}
            {discount === 1 && discountSum ? (
              <h4 className={bookingPanel('price-calculation-text')}>
                <span className={bookingPanel('price-calculation-title')}>Скидка</span>
                {discountSum * -1}
              </h4>
            ) : (
              <h4 className={bookingPanel('price-calculation-text')}>
                <span className={bookingPanel('price-calculation-title')}>Скидка</span>
                {discount}
              </h4>
            )}
            <h4 className={bookingPanel('price-calculation-text')}>=</h4>

            <h4 className={bookingPanel('price-calculation-text')}>
              <span className={bookingPanel('price-calculation-title')}>Сумма со скидкой</span>
              {priceIncludingDiscount} ₽
            </h4>
          </div>
        )}
        <Button text="Ок" handleExternal={handleCloseModal} />
      </Modal>
    </>
  ) : (
    <div className={bookingPanel({ side, hide: !side && isHide })}>
      {/* eslint-disable-next-line */}
      {side || !isHide ? (
        <DealPanel
          id={id}
          DealId={userDealsId}
          reservBeginDate={reservBeginDate}
          reservEndDate={reservEndDate}
          stageId={stageId}
          contactless={contactless}
          dealTotal={dealTotal}
          dealFullpay={dealFullpay}
          dealAllpay={dealAllpay}
          dealRisk={dealRisk}
          dealPrepay={dealPrepay}
          dealSurcharge={dealSurcharge}
          dealDiscount={dealDiscount}
          dealBonus={dealBonus}
          dealCashback={dealCashback}
          dealTimeout={dealTimeout}
          dealManager={dealManager}
          deposit={deposit}
          statusBooking={statusBooking}
          setStatusBooking={setStatusBooking}
          anotherDeal={anotherDeal}
          setAnotherDeal={setAnotherDeal}
          dealWiFiLogin={dealWiFiLogin}
          dealWiFiPassword={dealWiFiPassword}
          dealCode={dealCode}
        />
      ) : (
        <>
          <Button
            text="Бронирование"
            externalClassName={bookingPanel('button')}
            handleExternal={() => setHide(false)}
          />
        </>
      )}
    </div>
  );
};

export default BookingPanel;
